import { css1, css2 } from './result'

export const quizStarterTemplates = [
  { name: 'No Style', css: '' },
  { name: 'Modern', css: css1 },
  { name: 'Rounded', css: css2 },
]
